import { appState } from "../redux/redux-config";
import api from "../api/api";

const facebook = {
    getAuthUrl: async function () {
        let token = appState().user.token;
        return await api.facebook.getAuthUrl(token);
    },
    callback: async function (code) {
        let token = appState().user.token;
        return await api.facebook.callback(token, code);
    },
    getStatus: async function () {
        let token = appState().user.token;
        return await api.facebook.getStatus(token);
    },
    disconnect: async function () {
        let token = appState().user.token;
        return await api.facebook.disconnect(token);
    },
    authenticate: async function (
        code,
        pageId,
        pageName,
        pageAccessToken,
        userAccessToken,
    ) {
        let token = appState().user.token;
        return await api.facebook.authenticate(token, {
            code,
            userAccessToken,
            pageId,
            pageName,
            pageAccessToken,
        });
    },
    changePage: async function (pageId, pageName, pageAccessToken) {
        let token = appState().user.token;
        return await api.facebook.changePage(token, {
            pageId,
            pageName,
            pageAccessToken,
        });
    },
    getPages: async function (userAccessToken) {
        let token = appState().user.token;
        return await api.facebook.getPages(token, userAccessToken);
    },
    postToPage: async function (data) {
        let token = appState().user.token;
        return await api.facebook.postToPage(token, data);
    },
    togglePosting: async function () {
        let token = appState().user.token;
        return await api.facebook.togglePosting(token);
    },
};

export default facebook;